import script from "./Observations.vue?vue&type=script&setup=true&lang=js"
export * from "./Observations.vue?vue&type=script&setup=true&lang=js"

import "./Observations.vue?vue&type=style&index=0&id=177bd713&lang=css"
import "./Observations.vue?vue&type=style&index=1&id=177bd713&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-177bd713"]])

export default __exports__